import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../components/Link';
import Autosuggest from 'react-autosuggest';
import { translate } from 'react-i18next';

import MdMenu from 'react-icons/lib/md/menu';
import MdClose from 'react-icons/lib/md/close';
import MdSearch from 'react-icons/lib/md/search';

import StocksIcon from '../components/icons/Stocks';
import IndicesIcon from '../components/icons/Indices';
import CurrenciesIcon from '../components/icons/Currencies';
import CommoditiesIcon from '../components/icons/Commodities';
import FundIcon from '../components/icons/Fund';
import InterestsIcon from '../components/icons/Interests';

import css from '../styles/searchfield';

class SearchField extends Component {
    static propTypes = {
        query: React.PropTypes.string,
        results: React.PropTypes.array,
        isOpen: React.PropTypes.bool,
        search: PropTypes.func,
        toggleMenu: PropTypes.func.isRequired,
        focusSearch: PropTypes.bool,
        t: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = { focus: false };

        const t = this.props.t;

        this.types = {
            EQUITIES: { label: t('stocks'), icon: <StocksIcon /> },
            COMMODITY: { label: t('commodities'), icon: <CommoditiesIcon /> },
            FUNDS: { label: t('fund'), icon: <FundIcon /> },
            CURRENCIES: { label: t('currency'), icon: <CurrenciesIcon /> },
            ETPS: { label: t('etp'), icon: <StocksIcon /> },
            PCC: { label: t('equity'), icon: <StocksIcon /> },
            RIGHTS: { label: t('preemtiveRights'), icon: <StocksIcon /> },
            INDICES: { label: t('indices'), icon: <IndicesIcon /> },
            WARRANTS: { label: t('warrant'), icon: <StocksIcon /> },
            INTEREST: { label: t('interest'), icon: <InterestsIcon /> },
        };

        this._getType = (type, sel) => {
            if (this.types[type]) return this.types[type][sel];

            return '';
        };

        this._noop = () => {};

        this._toggleMenu = () => this.props.toggleMenu();

        this._handleSearchInput = e => {
            if (e.target.value !== this.props.query) {
                this.props.search(e.target.value || '');
            }
        };

        this._focusSearch = () => {
            if (this.autosuggest && this.autosuggest.input) {
                this.autosuggest.input.focus();
            }
        };

        this._closeHandler = () => {
            if (this.props.query) {
                this.props.search('');
                this._focusSearch();
            } else {
                this.props.toggleMenu();
            }
        };

        this.renderSuggestion = this.renderSuggestion.bind(this);

        this._getSuggestionValue = suggestion => suggestion.name || '';

        this._onFocus = () => this.setState({ focus: true });

        this._onBlur = () => {
            this.setState({ focus: false });
            if (this.autosuggest && this.autosuggest.input) {
                this.autosuggest.input.blur();
            }
        };
    }

    componentDidMount() {
        const { search, focusSearch } = this.props;

        if (search) search('');

        if (focusSearch) this._focusSearch();
    }


    getResults() {
        const { results } = this.props;

        if (!results.length) {
            return [''];
        }

        return results;
    }

    renderSuggestion(suggestion) {
        if (!this.props.isOpen) return null;

        if (suggestion.length === 0) {
            return (
                <div className={css.suggestionItem}>
                    <span className={css.noResults}>{this.props.t('noResult')}</span>
                </div>
            );
        }
        const { LONG_NAME, TYPE, ITEM, SECTOR } = suggestion;

        const symbol = `${ITEM}.${SECTOR}`;

        return (
            <Link
                to={`/instrument/${symbol}`}
                className={css.link}
                onClick={this._toggleMenu}
                metaTitle={ 'search' }
            >
                <div className={css.suggestionItem}>
                    <div className={css.suggestionName}>
                        <span>{LONG_NAME}</span>
                    </div>
                    <div className={css.suggestionSymbol}>
                        <span>{this._getType(TYPE, 'label')} · {symbol}</span>
                    </div>
                    <div className={css.suggestionIcon}>
                        {this._getType(TYPE, 'icon')}
                    </div>
                </div>
            </Link>
        );
    }

    render() {
        const { query, t } = this.props;

        const className = this.state.focus ? css.inputFieldFocus : css.inputField;

        const inputProps = {
            type: 'text',
            placeholder: t('search'),
            value: query,
            onChange: this._handleSearchInput,
            onFocus: this._onFocus,
            onBlur: this._onBlur,
            ref: c => (this._input = c),
        };

        return (
            <div className={className}>
                <div className={css.leftButtons}>
                    <div className={css.animationScrollDown}>
                        <div className={css.searchButton}>
                            <MdSearch size="24" />
                        </div>
                        <div className={css.searchButton}>
                            <MdMenu size="24" />
                        </div>
                    </div>
                </div>
                <div className={css.rightButtons} onClick={this._closeHandler}>
                    <div className={css.animationScrollDown}>
                        <div className={css.closeButton}>
                            <MdClose size="24" />
                        </div>
                        <div className={css.closeButton}>
                            <MdSearch size="24" />
                        </div>
                    </div>
                </div>
                <Autosuggest
                    suggestions={this.getResults()}
                    getSuggestionValue={this._getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    onSuggestionsFetchRequested={this._noop}
                    onSuggestionsClearRequested={this._noop}
                    inputProps={inputProps}
                    focusInputOnSuggestionClick={false}
                    theme={css}
                    alwaysRenderSuggestions
                    ref={autosuggest => (this.autosuggest = autosuggest)}
                />
            </div>
        );
    }
}

export default translate('menu')(SearchField);



/** WEBPACK FOOTER **
 ** /src/shared/parts/SearchField.js
 **/